import type { StackProps } from '@mui/material';

import {
  Section,
  NameBanner,
  CustomizedAccordion,
} from '@rumblefish/ui/Rumblefish23Theme';
import { scrollToElement } from '../../../utils/handleScroll';
import { contactFormId } from '../const';
import {
  AccordionData,
  SmartContractDevelopmentServicesData,
} from './SmartContractDevelopmentServices.data';
import {
  MainText,
  StyledStack,
  StyledButton,
  DescriptionText,
  StyledTextStack,
  StyledLinkWrapper,
  StyledContentStack,
  StyledAccordionStack,
} from './styles';

export const SmartContractDevelopmentServices = ({
  ...props
}: StackProps): React.ReactElement => {
  return (
    <Section width="normal">
      <StyledStack {...props}>
        <NameBanner type="section" text="Services" color="orange" />
        <StyledContentStack>
          <StyledTextStack>
            <MainText variant="display_sm">
              {SmartContractDevelopmentServicesData.mainText}
            </MainText>
            <DescriptionText variant="strong_400">
              {SmartContractDevelopmentServicesData.description}
            </DescriptionText>
          </StyledTextStack>
          <StyledAccordionStack>
            <CustomizedAccordion
              data={AccordionData()}
              CustomButton={
                <StyledLinkWrapper>
                  <StyledButton onClick={() => scrollToElement(contactFormId)}>
                    Book a free consultation
                  </StyledButton>
                </StyledLinkWrapper>
              }
            />
          </StyledAccordionStack>
        </StyledContentStack>
      </StyledStack>
    </Section>
  );
};
